<script lang="ts" setup>
import { reactive } from 'vue'
import type { GlobImageI } from '~/utils'
import { getImageURL } from '~/utils'
import { useSwiper } from '~/composables/common/use-swiper'
import { getLogoPartners, getFooterMenus, logoBanks } from '~/resources/footer/navigation-menu'
import { useNavigationBar } from '~/composables/common/use-navigation-bar'
import { useContact } from '~/composables/common/use-contact'
import { useCommon } from '~/composables/common/use-common'

const { clickLogo } = useNavigationBar()
const { fetchContact, emailSupport, telegramSupport } = useContact()
const { openLiveChat } = useCommon()
const config = useRuntimeConfig()

const { BRAND_NAME, INDIRECT_BRAND_NAME, INDIRECT_BRAND2_NAME } = config.public
const { modules } = useSwiper()

fetchContact()
const newFooterMenus = reactive(getFooterMenus())

const globImages: GlobImageI = import.meta.glob('~/assets/images/logo/footer/*', { eager: true })

const iconImgUrl = '/assets/images/logo/footer'
</script>
<template>
  <footer class="footer">
    <div class="footer-wrap">
      <div class="container">
        <div class="list-partner">
          <div v-for="item in getLogoPartners()" :key="item.title" class="list-partner__item">
            <NuxtLink v-if="item.link" :to="item.link" target="_blank" rel="nofollow">
              <img :src="item.logo" :alt="item.title" class="list-partner__logo" :title="item.title" />
            </NuxtLink>
            <img v-else :src="item.logo" :alt="item.title" class="list-partner__logo" />
          </div>
        </div>
        <hr style="margin: 0rem" />
      </div>

      <div class="footer-content">
        <div class="container">
          <div class="row">
            <div class="footer-content__right">
              <div class="d-flex widget-wrapper">
                <div class="widget">
                  <div class="logo cursor-pointer" style="margin-bottom: 16px" @click="clickLogo">
                    <img
                      :src="getImageURL(globImages, 'logo', iconImgUrl, 'webp')"
                      width="174"
                      height="56"
                      alt="Logo Footer"
                    />
                  </div>
                  <div class="footer-support">
                    <div class="footer-support__title fs-14 fw-400">
                      {{ BRAND_NAME }} - nhà cái uy tín hàng đầu và đại lý số 1 của
                      {{ StringUtils.capitalizeFirstCharacter(INDIRECT_BRAND_NAME.toLowerCase()) }} và
                      {{ StringUtils.capitalizeFirstAndLastCharacter(INDIRECT_BRAND2_NAME.toLowerCase()) }}, mang đến
                      trải nghiệm cá cược trực tuyến đẳng cấp. Với đa dạng sản phẩm, bảo mật tuyệt đối và khuyến mãi
                      hấp dẫn, {{ BRAND_NAME }} là lựa chọn hàng đầu cho người chơi Việt. Khám phá ngay!
                    </div>
                  </div>
                </div>
                <div v-for="(menu, index) in newFooterMenus" :key="index" class="widget">
                  <div class="widget__title fs-14 fw-700">{{ menu.title }}</div>
                  <ul class="widget__menu">
                    <li v-for="(category, i) in menu.subMenus" :key="i" class="widget__item">
                      <NuxtLink :to="category.link" class="widget__link">{{ category.subTitle }}</NuxtLink>
                    </li>
                  </ul>
                </div>

                <section class="widget">
                  <div class="widget__title">HỖ TRỢ 24/7</div>

                  <ul class="widget__menu">
                    <li v-if="emailSupport" class="widget__item">
                      <NuxtImg src="/assets/images/icons/contact/icon-email.svg" alt="email" width="24" />
                      <NuxtLink :to="emailSupport.link" class="widget__link" target="_blank">
                        {{ emailSupport.title }}
                      </NuxtLink>
                    </li>
                    <li v-if="telegramSupport" class="widget__item">
                      <NuxtImg src="/assets/images/icons/contact/icon-telegram.svg" alt="telegram" width="24" />
                      <NuxtLink :to="telegramSupport.link" class="widget__link" target="_blank">
                        {{ telegramSupport.title }}
                      </NuxtLink>
                    </li>
                    <li class="widget__item">
                      <NuxtImg src="/assets/images/icons/contact/icon-chat.svg" alt="chat" width="24" />
                      <a class="widget__link" @click="openLiveChat">Chat với CSKH</a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
          <hr style="margin: 0rem" />
          <div class="footer-content__bottom">
            <div class="footer-content__bank-support">
              <Swiper :modules="modules" slidesPerView="auto" :spaceBetween="12" loop autoplay grabCursor>
                <SwiperSlide v-for="bank in logoBanks" :key="bank.title">
                  <div class="bank-support-item">
                    <img :src="bank.logo" :alt="bank.title" class="bank-support-logo" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/layouts/footer/index.scss';
</style>
